import { ContentCard } from "@shared";
import { FormikProps } from "formik";

import { HoursInputField } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/components/hours-input-field/HoursInputField";
import { CounselorWorkTimeFormValues } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/work-time/CounselorWorkTime.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CounselorWorkTimeFormValues>;
}

export function ContractualHoursCard({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <ContentCard title={t("counselors.workTime.contractualHours.title")} sx={{ flex: 0 }}>
      <HoursInputField
        formik={formik}
        fieldName="weeklyHours"
        label={t("counselors.workTime.contractualHours.weeklyHours")}
        unit={t("counselors.workTime.contractualHours.weeklyHoursUnit")}
        required
      />
    </ContentCard>
  );
}
